import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DiagnosticOPEEnum} from "./DiagnosticOPEEnum";
import {GatewayStatusEnum} from "../../models/gateway/GatewayStatusEnum";


class I {
  partitionId!: number;
  gatewayAlarmStatusSet: number[];
  deviceAlarmStatusSet: number[];

  constructor() {
    this.gatewayAlarmStatusSet = [];
    this.deviceAlarmStatusSet = [];
  }


}

class O {
  partitions!: PartitionAlarmDTO[];
}


class PartitionAlarmDTO {

  id!: number;
  name!: string;
  path!: string;
  hasAlarms!: boolean;
  gateways!: GatewayAlarmDTO[];

}

class GatewayAlarmDTO {
  id!: number;
  name!: string;
  alarmStatus!: number;
  status!: GatewayStatusEnum;
  devices!: DeviceAlarmDTO[];
}


class DeviceAlarmDTO {
  id!: number;
  name!: string;
  alarmStatus!: number;
}


export class GetDiagnosticStatusCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DiagnosticOPEEnum.GetDiagnosticStatus);
    this.i = new I();
    this.o = new O();
  }
}
